import { render, staticRenderFns } from "./ClinicPageNotifications.vue?vue&type=template&id=75e05093"
import script from "./ClinicPageNotifications.vue?vue&type=script&lang=js"
export * from "./ClinicPageNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports